import ProductDetailsStore from './ProductDetailsStore'

export default ProductDetailsStore
